
// web font


// wordpress admin css
// normalize CSS across browsers
import "./src/css/@wordpress/load-styles.css"
import "./src/css/@wordpress/block-library/build-style/style.css"
import "./src/css/normalize.css"

//Custom CSS
import "../assets/css/style.css"

//Global CSS of wordpress.
import "./src/css/gutenberg-global.css"
import "../theme-options-style.css"

//lazyload
import "lazysizes"

//custom js
import "./static/custom.js"
import React from "react"

import wrapWithProvider from "./wrap-with-provider"
export const wrapRootElement = wrapWithProvider

export { wrapPageElement } from "./gatsby-shared"

/**
 * Msgboxx WhatsApp widget – Walton-On-Thames office page only.
 *
 * Injects the Msgboxx CSS, JS and widget container on:
 *   /offices/walton-on-thames-property-lettings/
 */
export const onRouteUpdate = ({ location }) => {
  const path = location && location.pathname ? location.pathname : ""

  // Only run on the Walton-On-Thames office pages
  const shouldInitMsgboxx =
    path === "/offices/walton-on-thames-property-lettings/" ||
    path === "/offices/walton-on-thames-estate-agents/"

  if (!shouldInitMsgboxx) {
    // If we navigate away from those pages, clean up Msgboxx artefacts
    const existingWidget = document.getElementById("msgboxxWidget")
    if (existingWidget && existingWidget.parentNode) {
      existingWidget.parentNode.removeChild(existingWidget)
    }

    const existingScript = document.querySelector('script[data-msgboxx="js"]')
    if (existingScript && existingScript.parentNode) {
      existingScript.parentNode.removeChild(existingScript)
    }

    const existingCss = document.querySelector('link[data-msgboxx="css"]')
    if (existingCss && existingCss.parentNode) {
      existingCss.parentNode.removeChild(existingCss)
    }

    return
  }

  // 1) Inject Msgboxx CSS once
  if (!document.querySelector('link[data-msgboxx="css"]')) {
    const link = document.createElement("link")
    link.rel = "stylesheet"
    link.href = "https://cdn.msgboxx.io/static/css/bundle.min.css"
    link.setAttribute("data-msgboxx", "css")
    document.head.appendChild(link)
  }

  // 2) Ensure widget container exists
  if (!document.getElementById("msgboxxWidget")) {
    const div = document.createElement("div")
    div.id = "msgboxxWidget"
    document.body.appendChild(div)
  }

  // 3) Inject / initialise Msgboxx JS on every entry to these pages
  const existingScript = document.querySelector('script[data-msgboxx="js"]')
  if (existingScript && existingScript.parentNode) {
    existingScript.parentNode.removeChild(existingScript)
  }

  const script = document.createElement("script")
  script.src = "https://cdn.msgboxx.io/static/js/bundle.min.js"
  script.async = true
  script.setAttribute("data-msgboxx", "js")
  script.onload = () => {
    window.msgboxxClient = "SEYWOT"
  }
  document.body.appendChild(script)
}

